import createAsyncTransaction from '../../helpers';

export const LOGIN = createAsyncTransaction('LOGIN');

export const LOGOUT = createAsyncTransaction('LOGOUT');

export const REGISTER = createAsyncTransaction('REGISTER');



// WEBPACK FOOTER //
// ./src/store/modules/auth/transactions.js